function defaultIsSelectAllOption (option) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (option === null || option === void 0 ? void 0 : option.value) === -1;
}

export default defaultIsSelectAllOption;
//# sourceMappingURL=default-is-select-all-option.esm.js.map
